import React from 'react';

export default function PhilosophyPage() {
  return (
    <main className="marketing-root">
      <div className="container py-12 space-y-12">
        <section className="marketing-hero marketing-hero--compact">
          <div className="marketing-orb orb-one" />
          <div className="marketing-orb orb-two" />
          <div className="marketing-hero__layout">
            <div>
              <p className="marketing-kicker">Our philosophy</p>
              <h1 className="marketing-heading text-4xl font-bold mb-3">Clubs first. Always.</h1>
              <p className="marketing-lede">
                Member Nest exists to reduce admin load and help grassroots clubs thrive. We build with clarity,
                trust, and respect for your time and data.
              </p>
            </div>
            <div className="marketing-hero__panel">
              <h3 className="marketing-heading text-2xl font-semibold">Our promise</h3>
              <div className="marketing-steps">
                {[
                  'No ad tech, no profiling, no selling data, no cookies following you round the web',
                  'Here to help grassroots clubs thrive, making it easier and simpler to run your community',
                  'Tools designed to make admin simpler, not heavier',
                ].map((text, idx) => (
                  <div key={text} className="marketing-step">
                    <div className="marketing-step__index">{idx + 1}</div>
                    <p className="text-gray-700">{text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="marketing-section">
          <div className="marketing-section__header">
            <h2 className="marketing-heading text-3xl font-semibold mb-2">How we build</h2>
            <p className="marketing-lede">
              We care about clarity, fairness, and products that feel helpful from day one.
            </p>
          </div>
          <div className="marketing-grid">
            {[
              {
                icon: 'CL',
                title: 'Clarity over complexity',
                desc: 'Every workflow should be easy to explain in one sentence.',
              },
              {
                icon: 'RS',
                title: 'Respect for members',
                desc: 'No ads, no unnecessary data collection, no following you round the internet.',
              },
              {
                icon: 'MD',
                title: 'Modular by design',
                desc: 'Switch on only what you need and add more when it helps.',
              },
              {
                icon: 'PR',
                title: 'Privacy as default',
                desc: 'We only store what\'s required to run your club.',
              },
            ].map((item) => (
              <div key={item.title} className="marketing-card">
                <div className="marketing-card__icon">{item.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="marketing-band">
          <div>
            <h2 className="marketing-heading text-3xl font-semibold">No tracking. No noise.</h2>
            <p className="marketing-lede">
              We don't run advertising cookies or third-party trackers. We don't sell data. We don't
              build profiles for marketing. Member Nest is simply built to help clubs run better.
            </p>
          </div>
        </section>

        <section className="marketing-section text-center">
          <h2 className="marketing-heading text-3xl font-semibold mb-2">Questions about privacy?</h2>
          <p className="marketing-lede">
            Reach us any time at support@member-nest.com and we'll answer directly.
          </p>
        </section>
      </div>
    </main>
  );
}
